import { render, staticRenderFns } from "./ExcLabel.vue?vue&type=template&id=b2bc14b2&scoped=true&"
import script from "./ExcLabel.vue?vue&type=script&lang=ts&"
export * from "./ExcLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ExcLabel.vue?vue&type=style&index=0&id=b2bc14b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc14b2",
  null
  
)

export default component.exports